import { render } from "./LoginTip.vue?vue&type=template&id=f6a6db30&scoped=true"
import script from "./LoginTip.vue?vue&type=script&lang=js"
export * from "./LoginTip.vue?vue&type=script&lang=js"

import "./LoginTip.vue?vue&type=style&index=0&id=f6a6db30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a6db30"]])

export default __exports__